import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "./components/Header";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Paiement from "./components/Paiement";
import Simulateur from "./components/Simulateur";
import Services from "./components/Services";
import APropos from "./components/APropos";
import ContactEstimation from "./components/ContactEstimation";
import Footer from "./components/Footer";

function Home() {
  return (
    <main className="bg-[#F8F4EC] text-[#001226] min-h-screen">
      <Header />
      <Hero />
      <Marquee />
      <Paiement />
      <Simulateur />
      <Services />
      <APropos />
      <ContactEstimation />
      <Footer />
      <Toaster
        theme="light"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            border: "1px solid rgba(0,18,38,0.12)",
            color: "#001226",
            borderRadius: 0,
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </main>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
